<template>
	<div class="flex flex-grow">
		<div class="md:gap-1 flex-grow items-baseline">
			<div>
				<div class="w-full" v-if="!isLoading">
					<div class="w-full mb-20">
						<div>
							<div class="main text-left">
								<div>
									<div class="font-bold mb-4">{{ $t('classify_vehicle_by_assessor_input') }}</div>
									<div class="mb-4">{{ isAppContainer ? $t('scan_or_upload_vehicle_registration') : $t('upload_vehicle_registration') }}</div>
									<div class="mb-4">
										<div class="flex justify-center" v-if="vehicle.registrationImage.base64Content">
											<BaseImage :src="vehicle.registrationImage.base64Content" :alt="$t('vehicle_registration')" class="mb-4 w-full" />
										</div>
										<div class="flex flex-grow justify-center">
											<BaseCamera
												orientation="landscape"
												@snapshot="vehicle.registrationImage.base64Content = $event"
												:label="$t('add_vehicle_registration')"
												:take-image-label="$t('activate_camera_for_registration_image')"
												:remove-upload-button="isAppContainer"
												:take-image="true"
												:allow-upload-in-app-container="false"
												:enable-preview="false"
												accept="image/*, application/pdf"
											/>
										</div>
									</div>
									<div class="mb-4">
										{{ $t('check_fields_input') }}
									</div>
								</div>
								<div>
									<div class="w-full">
										<div class="w-full flex justify-center">
											<LicensePlateInput ref="LicensePlateInput" v-model="vehicle.licensePlate" show-only="regular" />
										</div>
									</div>
									<div class="md:flex md:space-x-4">
										<div class="md:w-1/2">
											<AutocompleteInput
												ref="fahrzeughersteller"
												v-model="vehicle.manufacturer"
												:required="true"
												:label="$t('manufacturer_sample')"
												mask="AXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX"
												@input="updateManufacturer"
												@selectValue="selectManufacturer"
												:options="manufacturerList"
												@blur="manufacturerList = null"
											/>
										</div>
										<div class="md:w-1/2">
											<AutocompleteInput
												ref="BaseInput.value.model"
												v-model="vehicle.model"
												:required="true"
												:label="$t('model_sample')"
												mask="BXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX"
												@input="updateModel"
												@click="updateModel('')"
												@selectValue="selectModel"
												:options="modelList"
												@blur="modelList = null"
											/>
										</div>
									</div>
									<div class="xl:flex">
										<BaseInput
											ref="baseInputvehicleIdentificationNumber2"
											type="hidden"
											validation="[^IOQ]{17}"
											mask="BBBBBBBBBBBBBBBBB"
											maxlength="17"
											v-model="vehicle.vehicleIdentificationNumber"
											:required="false"
										/>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<LoadingSpinner v-else />
			</div>
		</div>
	</div>
</template>

<script>
import LoadingSpinner from '@/components/navigation/LoadingSpinner.vue';
import Authentication from '@/mixins/Authentication';
import RentalCarForm from '@/components/rentalcars/forms/RentalCarForm.vue';
import BaseInput from '@/components/forms/inputs/BaseInput.vue';
import AppContainerMixin from '@/mixins/AppContainerMixin';
import BaseImage from '@/components/forms/BaseImage.vue';
import AutocompleteInput from '@/components/forms/inputs/AutocompleteInput.vue';
import LicensePlateInput from '@/components/forms/inputs/LicensePlateInput.vue';
import VehicleRepository from '@/api/repositories/VehicleRepository';
import BaseCamera from '@/components/forms/inputs/BaseCamera.vue';
import Validate from '@/mixins/Validate';

export default {
	components: { BaseCamera, LicensePlateInput, AutocompleteInput, BaseImage, BaseInput, LoadingSpinner },
	name: 'OnboardingCompanyRentalCarsAdd',
	mixins: [Validate, Authentication, AppContainerMixin],
	data() {
		return {
			isLoading: false,
			vehicle: {
				registrationImage: {
					base64Content: null,
				},
				licensePlate: null,
				manufacturer: null,
				model: null,
				vehicleIdentificationNumber: null,
				rentalCarClass: null,
			},
			updateModelTimeoutId: null,
			updateManufacturerTimeoutId: null,
			selectedManufacturer: null,
			selectedModel: null,
			manufacturerList: [],
			modelList: [],
		};
	},
	mounted() {},
	methods: {
		clearForm() {
			this.isLoading = true;
			this.vehicle = {
				registrationImage: {
					base64Content: null,
				},
				licensePlate: null,
				manufacturer: null,
				model: null,
				vehicleIdentificationNumber: null,
				rentalCarClass: null,
			};
			this.selectedModel = null;
			this.selectedManufacturer = null;
			this.isLoading = false;
		},
		updateManufacturer(value) {
			if (value === this.selectedManufacturer) return;
			this.selectedManufacturer = null;
			clearTimeout(this.updateManufacturerTimeoutId);
			this.updateManufacturerTimeoutId = setTimeout(() => {
				new VehicleRepository().getManufacturerNames(value).then(response => {
					this.manufacturerList = response.data?.map(manufacturer => manufacturer.name);
				});
			}, 300);
		},
		updateModel(value) {
			this.modelList = null;
			if (value === this.selectedModel) return;
			clearTimeout(this.updateModelTimeoutId);
			this.updateModelTimeoutId = setTimeout(() => {
				new VehicleRepository().getModelNames(value, this.vehicle.manufacturer).then(response => {
					this.modelList = response.data?.map(model => model.name);
				});
			}, 300);
		},
		selectManufacturer(manufacturer) {
			this.selectedManufacturer = manufacturer;
			this.vehicle.manufacturer = manufacturer;
			clearTimeout(this.updateManufacturerTimeoutId);
		},
		selectModel(model) {
			this.selectedModel = model;
			this.vehicle.model = model;
			clearTimeout(this.updateModelTimeoutId);
		},
		getData() {
			if (!this.vehicle.registrationImage.base64Content) {
				this.isLoading = false;
				this.$swal(this.$t('general.error').toString(), this.$t('vehicle_registration_missing').toString(), 'error');
				return null;
			} else {
				return { ...this.vehicle };
			}
		},
	},
};
</script>
